if (!customElements.get('movitamins-reviews')) {
  customElements.define(
    'movitamins-reviews',
    class MovitaminsReviews extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-reviews-viewport]');
        this.list = this.querySelector('[data-reviews-list]');
        this.previous = this.querySelector('[data-reviews-previous]');
        this.next = this.querySelector('[data-reviews-next]');
        if (!this.viewport || !this.list) return;

        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.animating = false;
        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);

        this.previous?.addEventListener('click', () => this.move(-1));
        this.next?.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.update();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      cardStep() {
        const card = this.list.querySelector('.mvr__item');
        if (!card) return this.viewport.clientWidth;
        const styles = getComputedStyle(this.list);
        const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
        return card.getBoundingClientRect().width + gap;
      }

      maxScroll() {
        return Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
      }

      update() {
        const max = this.maxScroll();
        const left = this.viewport.scrollLeft;
        if (this.previous) this.previous.disabled = left <= 2;
        if (this.next) this.next.disabled = left >= max - 2;
      }

      move(direction) {
        const step = this.cardStep();
        const max = this.maxScroll();
        const index = Math.round(this.viewport.scrollLeft / step);
        const target = Math.min(max, Math.max(0, (index + direction) * step));
        this.scrollToPosition(target);
      }

      scrollToPosition(target) {
        const from = this.viewport.scrollLeft;
        const distance = target - from;
        if (Math.abs(distance) < 1) return;
        if (this.reducedMotion.matches) {
          this.viewport.scrollLeft = target;
          this.update();
          return;
        }
        if (this.animating) cancelAnimationFrame(this.frame);
        this.animating = true;
        const duration = 520;
        const start = performance.now();
        const snap = this.viewport.style.scrollSnapType;
        this.viewport.style.scrollSnapType = 'none';
        const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);
        const frame = (now) => {
          const t = Math.min(1, (now - start) / duration);
          this.viewport.scrollLeft = from + distance * ease(t);
          if (t < 1) {
            this.frame = requestAnimationFrame(frame);
            return;
          }
          this.viewport.style.scrollSnapType = snap;
          this.animating = false;
          this.update();
        };
        this.frame = requestAnimationFrame(frame);
      }
    }
  );
}
